import { Accessibility, ShieldCheck, Leaf, ClipboardCheck, FileText, Building2, HardHat } from "lucide-react";

const IMG = "https://static.prod-images.emergentagent.com/jobs/e8e12723-cc26-432f-b8f7-16b7fdc20e73/images/";

export const IMAGES = {
  hero: IMG + "5a71170baeac5edce38cb17988b7de425e217cb2f179e6904c0b3f7529f8f739.jpeg",
  bathroom: IMG + "00f30cce40b4923e5a5a08ad0b45398246f5087f1755e8443fad95da43a4f1f8.jpeg",
  advisor: IMG + "7b96113401f292e60805187e90bbaa88605aa30c610c32970c33155c00da8a9e.jpeg",
  diagnostic: IMG + "c8b7b380cbac18231aa4ea54cc4129e01a13dd5e2c8e635fb37b91cdf720ed2f.jpeg",
  pros: IMG + "fc0e80bb64f76a59c627c10e756d3e30926688aa30074d0b3507f7e0e47f0968.jpeg",
  energy: IMG + "33fbc5df7cd611f26302bbbdcd8279feb62aac64c531b0044dcc75692ac94e9a.jpeg",
  worksite: IMG + "5bbb3df452f62a16ffc24b9c8f658d87b28cd7adde10500ebe798e2878c8e2ac.jpeg",
  entrance: IMG + "c007c890a126a942c8130962445db545812031b36e52f8ccb345b5c14222c37c.jpeg",
  aidant: IMG + "675d1a0e80f4af1a3272aa1b2a23c80130df3f36de68a900e841bf101adc9bde.jpeg",
};

export const COMPANY = {
  name: "Habitalys",
  form: "SAS à associé unique",
  capital: "1 000,00 €",
  street: "28 Avenue des Pépinières",
  city: "94260 Fresnes",
  rcs: "RCS Créteil 100 284 611",
  siren: "100 284 611",
  siret: "100 284 611 00017",
  tva: "FR03100284611",
  euid: "FR9401.100284611",
  naf: "71.12B — Activité des économistes de la construction",
  president: "Lassana DIARRA",
  created: "30/01/2026",
  email: "habitalys@atomicmail.io",
};

export const IDF_DEPTS = [
  ["75", "Paris"], ["77", "Seine-et-Marne"], ["78", "Yvelines"], ["91", "Essonne"],
  ["92", "Hauts-de-Seine"], ["93", "Seine-Saint-Denis"], ["94", "Val-de-Marne"], ["95", "Val-d'Oise"],
];
export const NEIGHBOR_REGIONS = ["Hauts-de-France", "Normandie", "Centre-Val de Loire", "Bourgogne-Franche-Comté", "Grand Est"];

export const SERVICES = [
  { slug: "adaptation-logement", title: "Adaptation du logement", short: "Autonomie, salle de bain, accessibilité : un logement pensé pour la personne.", icon: Accessibility, image: IMAGES.bathroom },
  { slug: "securisation", title: "Sécurisation du logement", short: "Prévention des chutes, éclairage, circulations et dispositifs de sécurité.", icon: ShieldCheck, image: IMAGES.entrance },
  { slug: "renovation-energetique", title: "Rénovation énergétique", short: "Confort, factures maîtrisées et parcours d'aides MaPrimeRénov' / CEE.", icon: Leaf, image: IMAGES.energy },
  { slug: "diagnostics", title: "Diagnostics accessibilité & éligibilité", short: "État des lieux du logement et de votre éligibilité aux aides.", icon: ClipboardCheck, image: IMAGES.diagnostic },
  { slug: "montage-dossiers-aides", title: "Montage des dossiers d'aides", short: "MaPrimeAdapt', MaPrimeRénov', Anah, CEE, caisses de retraite, aides locales.", icon: FileText, image: IMAGES.aidant },
  { slug: "amo-maitrise-ouvrage-deleguee", title: "AMO & maîtrise d'ouvrage déléguée", short: "Un expert à vos côtés pour piloter votre projet de bout en bout.", icon: Building2, image: IMAGES.pros },
  { slug: "coordination-suivi-travaux", title: "Coordination & suivi de travaux", short: "Planification, coordination des entreprises, contrôle et réception.", icon: HardHat, image: IMAGES.worksite },
];

export const NAV_LINKS = [
  { to: "/particuliers", label: "Particuliers" },
  { to: "/professionnels", label: "Professionnels" },
  { to: "/aides-financieres", label: "Aides" },
  { to: "/zone-intervention", label: "Zone" },
  { to: "/tarifs", label: "Tarifs" },
];

export const MORE_LINKS = [
  { to: "/notre-methode", label: "Notre méthode" },
  { to: "/simulateur", label: "Simulateur d'éligibilité" },
  { to: "/ressources", label: "Ressources" },
  { to: "/faq", label: "FAQ" },
  { to: "/a-propos", label: "À propos" },
];

export const euros = (cents) => (cents / 100).toLocaleString("fr-FR", { style: "currency", currency: "EUR" });

export const AID_NOTICE = "Montants indicatifs, sous réserve d'éligibilité et des règles en vigueur.";
